import React from 'react';
import * as Mapbox from "react-map-gl/mapbox";
import {FillLayerSpecification, LayerSpecification, LineLayerSpecification, SymbolLayerSpecification} from 'mapbox-gl';
import {MapLayer} from "../../../types/MapLayers";

// Types ----

type InteractionAreaLayerProps = {
  source?: string
  enabledLayers: MapLayer[]
}

// Component ----

function InteractionAreaLayer({source = '', enabledLayers} : InteractionAreaLayerProps) {

  // Filters
  const interactionAreaFilter = ["==", "type", "interaction-area"]

  // Layout Properties
  const layout: LayerSpecification['layout'] = { visibility: enabledLayers.includes(MapLayer.INTERACTION_AREA) ? "visible" : "none" };

  return (
    <>
      <Mapbox.Layer
        type="fill"
        id="ngage-interaction-area"
        source={source}
        filter={interactionAreaFilter}
        paint={interactionAreaPaint}
        layout={layout}
      />

      <Mapbox.Layer
        type="line"
        id="ngage-interaction-area-outline"
        source={source}
        filter={interactionAreaFilter}
        paint={interactionAreaOutlinePaint}
        layout={layout}
      />

      <Mapbox.Layer
        type="symbol"
        id="ngage-interaction-area-name"
        source={source}
        filter={interactionAreaFilter}
        layout={{...interactionAreaNameLayout, ...layout}}
        paint={interactionAreaNamePaint}
      />
    </>
  );
}

// Styles ----

const interactionAreaPaint: FillLayerSpecification['paint'] = {
  "fill-color": "#f59e0b",
  "fill-opacity": 0.3,
}

const interactionAreaOutlinePaint: LineLayerSpecification['paint'] = {
  "line-color": "#f59e0b",
  "line-width": 2,
  "line-dasharray": [1, 1],
}

const interactionAreaNameLayout: SymbolLayerSpecification['layout'] = {
  "text-field": ["get", "name"],
  "text-anchor": "center",
}

const interactionAreaNamePaint: SymbolLayerSpecification['paint'] = {
  "text-halo-width": 2,
  "text-halo-color": "#FFFFFF",
}

export default InteractionAreaLayer;